import { Navigate } from '@tanstack/react-router';
import { useArtists } from '../api/queries';
import { Header } from '../components/Header';
import { ProblemBanner } from '../components/ProblemBanner';

/** Lands on the last artist the browser showed, else the first artist in the store. */
export function IndexPage() {
  const artists = useArtists();
  if (artists.isPending)
    return (
      <>
        <Header />
        <div className="wrap loading">Loading artists…</div>
      </>
    );
  if (artists.isError)
    return (
      <>
        <Header />
        <div className="wrap">
          <ProblemBanner error={artists.error} />
        </div>
      </>
    );
  let last: string | null = null;
  try {
    last = localStorage.getItem('lastArtistId');
  } catch {
    last = null;
  }
  const first = artists.data.data.find((a) => a.artistId === last) ?? artists.data.data[0];
  if (!first)
    return (
      <>
        <Header />
        <div className="wrap loading">No artists are ingested yet.</div>
      </>
    );
  return (
    <Navigate
      to="/a/$artistId"
      params={{ artistId: first.artistId }}
      search={{} as never}
      replace
    />
  );
}
